import React, { ReactElement, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { companies } from 'sections/Events/AnnualConferenceAttendeesList/data';
import styles from 'sections/Events/AnnualConferenceAttendeesList/components/SectionChart/SectionChart.module.scss';

const cn = classNames.bind(styles);

ChartJS.register(ArcElement, Tooltip, Legend);

const SectionChart = (): ReactElement => {
  const [members] = React.useState(() => {
    const memberInCountry: { country: string; amount: number }[] = [];

    const calculateAmountMemberInCountries = (list: any) => {
      const cacheArray: string[] = [];
      list.map((item: any) => {
        const countryName = item['Country'].trim();

        if (!cacheArray.includes(countryName) && !cacheArray.includes(item['Name'])) {
          const mountOfCountryUsers = list.filter((item: any) => item['Country'].trim() === countryName);

          memberInCountry.push({ country: countryName, amount: mountOfCountryUsers.length });
        }

        cacheArray.push(countryName);
        cacheArray.push(item['Name']);
      });
    };

    calculateAmountMemberInCountries(companies);

    return memberInCountry;
  });

  const [chartData, setChartData] = React.useState({
    labels: [],
    datasets: [
      {
        label: '# of Votes',
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          '#1142AA',
          '#6C8DD5',
          '#3714B0',
          '#1F0772',
          '#1F0723',
          '#009B95',
          '#33CDC7',
          '#FFA900',
          '#C6F500',
          '#800053',
          '#9261FA',
        ],
        borderColor: [
          '#1142AA',
          '#6C8DD5',
          '#3714B0',
          '#1F0772',
          '#1F0723',
          '#009B95',
          '#33CDC7',
          '#FFA900',
          '#C6F500',
          '#800053',
          '#9261FA',
        ],
        borderWidth: 1,
      },
    ],
  });

  useEffect(() => {
    let amountOfAllArray: { country: string; percent: number }[] = [];

    members.length &&
      members.slice().forEach((item) => {
        const calculateItem = Math.fround((item.amount / companies.length) * 100).toFixed(1);
        amountOfAllArray.push({ country: item.country, percent: +calculateItem });
      });

    const top10: { country: string; percent: number }[] = amountOfAllArray
      .sort((a, b) => b.percent - a.percent)
      .slice(0, 10);
    const rest: { country: string; percent: number } = {
      country: 'Others countries    ',
      percent: amountOfAllArray.slice(11).reduce((acc, item) => acc + item.percent, 0),
    };

    amountOfAllArray = [...top10, rest];

    setChartData({
      ...chartData,
      //@ts-ignore
      labels: amountOfAllArray.map((item) => item.country),
      datasets: [
        {
          ...chartData.datasets[0],
          data: amountOfAllArray.map((item) => item.percent),
        },
      ],
    });
  }, []);

  return (
    <section className={cn('chart')}>
      <div className={cn('container')}>
        <div className={cn('chart__container')}>
          <Doughnut
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      return tooltipItem.label.trim() + ': ' + tooltipItem.formattedValue + '%';
                    },
                  },
                },
                legend: {
                  onClick: function () {
                    return false;
                  },
                  fullSize: true,
                  display: true,
                  position: 'left',
                  labels: {
                    usePointStyle: true,
                    boxHeight: 18,
                    color: '',
                    font: {
                      family: 'Montserrat',
                    },
                  },
                },
              },
            }}
            plugins={[
              //@ts-ignore
              {
                beforeDraw: function (chart) {
                  const width = chart.width,
                    height = chart.height,
                    ctx = chart.ctx;
                  ctx.restore();
                  const fontSize = (width / 250).toFixed(2);
                  ctx.font = fontSize + 'em Montserrat';
                  //@ts-ignore
                  ctx.textBaseline = 'center';
                  const text = String(companies.length),
                    textX = Math.round((width - ctx.measureText(text).width) / 1.49),
                    textY = height / 2.1;
                  ctx.fillText(text, textX, textY);
                  ctx.save();
                },
              },
              //@ts-ignore
              {
                beforeDraw: function (chart) {
                  const width = chart.width,
                    height = chart.height,
                    ctx = chart.ctx;
                  ctx.restore();
                  const fontSize = (width / 400).toFixed(2);
                  ctx.font = fontSize + 'em Montserrat';
                  //@ts-ignore
                  ctx.textBaseline = 'center';
                  const text = 'COMPANIES',
                    textX = Math.round((width - ctx.measureText(text).width) / 1.4),
                    textY = height / 1.9;
                  ctx.fillText(text, textX, textY);
                  ctx.save();
                },
              },
            ]}
          />
        </div>
      </div>
    </section>
  );
};

export default SectionChart;